import { defaultThemeValues, protectedThemeProperties } from "./catalog";
import { currentThemeSchemaVersion, currentThemeVersion, } from "./contracts";
export const iafDefaultThemeDefinition = {
    schemaVersion: currentThemeSchemaVersion,
    themeVersion: currentThemeVersion,
    definitionId: "iaf-default",
    displayName: "IAF Default",
    status: "published",
    values: defaultThemeValues,
    protectedProperties: protectedThemeProperties.map((property) => property.propertyKey),
    compatibility: {
        schemaVersion: currentThemeSchemaVersion,
        themeVersion: currentThemeVersion,
        minimumSupportedIafVersion: "0.1.0",
        maximumTestedIafVersion: "0.1.0",
        migrationStatus: "not-required",
    },
    createdBy: "inteacc-design-system",
    createdAt: "2026-07-23T00:00:00.000Z",
    updatedAt: "2026-07-23T00:00:00.000Z",
};
export const inteaccBrandThemeDefinition = {
    ...iafDefaultThemeDefinition,
    definitionId: "inteacc-brand",
    displayName: "Inteacc Brand",
    values: {
        "brand.primary": "#1769aa",
        "brand.secondary": "#087e8b",
        "brand.logoReference": "asset://inteacc/logo/default",
        "brand.productIdentity": "Inteacc",
        "typography.family.primary": 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    },
};
export const defaultThemeSources = [
    {
        sourceId: "iaf:defaults",
        layer: "iaf",
        scope: { kind: "iaf" },
        definition: iafDefaultThemeDefinition,
    },
    {
        sourceId: "inteacc:brand",
        layer: "brand",
        scope: { kind: "brand", brandId: "inteacc" },
        definition: inteaccBrandThemeDefinition,
    },
];
//# sourceMappingURL=defaults.js.map